import React, { useMemo } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import useAdditionalUserData from "../hooks/useAdditionalUserData";
import { isOverviewModuleAllowed } from "./overviewAccess";

export default function RequireOverviewOrRedirect() {
  const location = useLocation();

  const headersSetCookie = localStorage.getItem("headersSetCookie");
  const persistedAccountUid = localStorage.getItem("accountUid");

  const additionalUserData = useAdditionalUserData();
  const roles = Array.isArray(additionalUserData?.roles) ? additionalUserData.roles : [];
  const isSuperUser = roles.includes("ROLE_SUPERUSER");
  const isAccountManager = roles.includes("ROLE_ACCOUNT_MANAGER");

  const cardParam = useMemo(() => {
    const match = location.pathname.match(/^\/dashboard\/overview\/([^/]+)/);
    return match ? match[1] : null;
  }, [location.pathname]);

  const redirectTo = useMemo(() => {
    if (!headersSetCookie) return "/login";
    if (isSuperUser) return "/dashboard/admin";
    if (!isAccountManager) return persistedAccountUid ? `/dashboard/${persistedAccountUid}` : "/dashboard";
    if (!isOverviewModuleAllowed(cardParam)) return "/dashboard/overview";
    return null;
  }, [headersSetCookie, isSuperUser, isAccountManager, persistedAccountUid, cardParam]);

  if (redirectTo) {
    const redirectState = !headersSetCookie ? { from: location } : null;
    return <Navigate to={redirectTo} state={redirectState} replace />;
  }

  return <Outlet />;
}
